import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import { ExclamationCircleOutlined, CheckCircleOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const SimplifiedInterestAlert = ({ interests = [] }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleEditInterests = () => navigate("/personal-interest");

  const selectedInterests = interests.flatMap((category) =>
    category.subCategories ? category.subCategories.map((sub) => sub.name) : []
  );
  const total = selectedInterests.length;
  const hasInterests = total > 0;

  if (!hasInterests) {
    return (
      <div className="sl-alert sl-alert--warn">
        <div className="sl-alert__main">
          <span className="sl-alert__icon">
            <ExclamationCircleOutlined />
          </span>
          <div>
            <div className="sl-alert__title">No focus areas selected</div>
            <div className="sl-alert__text">
              Pick 3 to 11 areas so we can recommend the right courses for you.
            </div>
          </div>
        </div>
        <Button type="primary" icon={<EditOutlined />} onClick={handleEditInterests}>
          Select interests
        </Button>
      </div>
    );
  }

  return (
    <div className="sl-alert sl-alert--info" style={{ flexDirection: "column", alignItems: "stretch" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <div className="sl-alert__main">
          <span className="sl-alert__icon">
            <CheckCircleOutlined />
          </span>
          <div>
            <div className="sl-alert__title">Your focus areas ({total} selected)</div>
            <div className="sl-alert__text">These shape your personalized recommendations.</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <Button type="text" onClick={() => setIsExpanded(!isExpanded)} style={{ color: "#9A6B0E" }}>
            {isExpanded ? "Show less" : "Show more"}
          </Button>
          <Button icon={<EditOutlined />} onClick={handleEditInterests}>
            Edit
          </Button>
        </div>
      </div>
      {isExpanded && (
        <div className="sl-alert__tags">
          {selectedInterests.map((name, index) => (
            <span className="sl-pill" key={index}>
              {name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

SimplifiedInterestAlert.propTypes = {
  interests: PropTypes.array,
};

export default SimplifiedInterestAlert;
